import React, { Suspense, lazy } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import "./Banner.css";
import parse from "html-react-parser";
import { Rates } from "rate-quotes";
import useFormModal from "../Utils/useFormModal";
import useSunWestSuccessYears from '../Utils/useSunWestSuccessYears';
const Widgets = lazy(() => import('../widgets/widget'))

export default function Banner({ data, loCommonData }) {

  const { title1, title2, text1, calSavingBtn, calSavingBtnLink, applyNowBtn, applyNowBtnLink, requestCallbackBtn, requestCallbackBtnLink, text2, text3, ratesTitle, ratesText } = data?.banner
  const applyNow = loCommonData?.angelaiUrl ? loCommonData?.angelaiUrl : applyNowBtnLink
  const imgCDN = process.env.REACT_APP_CDN + "refinance/images/";
  const { handleClick, renderModal } = useFormModal();
  const successYears = useSunWestSuccessYears();
  const loId = loCommonData?.loID
  const loEmail = loCommonData?.email || "";

  return (
    <>
      <div className="banner">
        <Container className="bannercontainer">
          <Row>
            <Col sm={12} md={12} lg={12}>
              <h1 className="title"><i><span className="title1">{parse(title1)}</span><span className="title2"> {parse(title2)}</span></i></h1>
              <h3 className="text1"><i>{parse(text1)}</i></h3>
              <div>
                <div className="today-rate-div">
                  <img src={imgCDN + "today-rate-border-left.webp"} alt="border" loading="lazy" />
                  <div className="banner-rate-div">
                    <p className="banner-rate-title">{parse(ratesTitle)}</p>
                    <p className="banner-rate-text">{parse(ratesText)}</p>
                  </div>
                  <img src={imgCDN + "today-rate-border-right.webp"} alt="border" loading="lazy" />
                </div>
                <div className="rate-quote">
                {loId ?
                <Rates leadSource="NET007" lOiD={loId} loanOfficerEmail={loEmail} defaultProduct="refinance"/>
                : <Rates leadSource="NET007" defaultProduct="refinance" />}
                </div>
              </div>
              <div className="btn-div-apply">
                <button className="apply-now-btn" onClick={() => handleClick(applyNow)}>{applyNowBtn}</button>
              </div>
              <div className="btn-div">
                <button className="cal-sav-btn" onClick={() => handleClick(calSavingBtnLink)}>{calSavingBtn}</button>
                <button className="request-callback-btn" onClick={() => handleClick(requestCallbackBtnLink)}>{requestCallbackBtn}</button>
              </div>
              <p className="text2">{parse(text2)} {successYears} {parse(text3)}</p>
              {renderModal()}
            </Col>
          </Row>
        </Container>
      </div>
      <Suspense fallback={<div></div>}>
        <Widgets />
      </Suspense>
    </>
  );
}
